import unAuth from "./unAuth.vue";
export default unAuth;
